'use client';

import dynamic from 'next/dynamic';

/**
 * -----------------------------------------------------------------------------
 * This provides options to customize the company logo based on the `logoId`.
 *
 * - We are loading this dynamically to prevent server side rendering it on when
 * the app has not loaded the tenant id yet, causing hydration errors in the browser.
 */
export const DisplayCurrency = dynamic(() => import('./DisplayCurrency'), {
  ssr: false,
});

DisplayCurrency.displayName = 'DisplayCurrency';

export { DirhamSymbolSvg } from './DirhamSymbolSvg';
